<p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true"></p-toast>

<div class="responsible-detail-container p-6 w-full">
  <!-- Breadcrumb -->
  <div class="mb-4">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()"
      [home]="{ icon: 'pi pi-home', routerLink: '/axa/suppliers-dashboard', ariaLabel: 'Home' }" [attr.aria-label]="'Breadcrumb navigation'"
    >
    </p-breadcrumb>
  </div>

  <!-- Page Header -->
  <div class="page-header mb-4">
    <div class="header-content">
      <div class="header-left">
        <button
          pButton
          icon="pi pi-arrow-left"
          class="p-button-text p-button-plain header-back-btn"
          (click)="goBack()"
          [attr.aria-label]="'Torna al Registro Responsabili'"
          title="Torna al Registro Responsabili"
        ></button>
        <div>
          <h1 id="page-heading" class="text-3xl font-bold m-0" style="color: #00125b">
            {{ manager().businessName || 'Dettaglio Responsible' }}
          </h1>
          <p class="text-color-secondary mt-2 mb-0">
            Visualizza e modifica i dettagli del responsible
          </p>
        </div>
      </div>
    </div>
  </div>

  @if (manager()) {
    <!-- ================= DATI RESPONSABILE ================= -->
    <section
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="responsible-data-heading"
    >
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-user text-2xl" style="color: #00125b" aria-hidden="true"></i>
        <h2 id="responsible-data-heading" class="text-xl font-semibold m-0">
          Dati Responsible del Trattamento
        </h2>
      </div>

      <div class="form-grid" [formGroup]="responsibleForm">
        <!-- Row 1 -->
        <div class="item">
          <label for="businessName"
            >Ragione Sociale del Responsabile del Trattamento
            <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <input
            id="businessName"
            pInputText
            formControlName="businessName"
            class="w-full"
            aria-required="true"
            [attr.aria-invalid]="
              responsibleForm.get('businessName')?.invalid &&
              responsibleForm.get('businessName')?.touched
            "
            [attr.aria-describedby]="
              responsibleForm.get('businessName')?.invalid &&
              responsibleForm.get('businessName')?.touched
                ? 'businessName-error'
                : null
            "
          />
          @if (isEditMode()) {
            <app-validation-error
              [control]="responsibleForm.get('businessName')"
              errorId="businessName-error"
              mode="strict"
            />
            <small class="block mt-1 text-600">Non inserire il tipo di società</small>
          }
        </div>

        <div class="item">
          <label for="companyType"
            >Tipo societa <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <p-select
            id="companyType"
            formControlName="companyType"
            [options]="companyTypeOptions"
            optionLabel="valueDescription"
            optionValue="valueKey"
            class="w-full"
            placeholder="Seleziona tipo societa"
            aria-required="true"
            [attr.aria-invalid]="
              responsibleForm.get('companyType')?.invalid &&
              responsibleForm.get('companyType')?.touched
            "
            [attr.aria-describedby]="
              responsibleForm.get('companyType')?.invalid &&
              responsibleForm.get('companyType')?.touched
                ? 'companyType-error'
                : null
            "
          ></p-select>
          @if (isEditMode()) {
            <app-validation-error
              [control]="responsibleForm.get('companyType')"
              errorId="companyType-error"
              mode="strict"
            />
          }
        </div>

        <!-- Row 2 -->
        <div class="item">
          <label for="headquarters"
            >Sede del Responsabile del Trattamento
            <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <input
            id="headquarters"
            pInputText
            formControlName="headquarters"
            class="w-full"
            aria-required="true"
            [attr.aria-invalid]="
              responsibleForm.get('headquarters')?.invalid &&
              responsibleForm.get('headquarters')?.touched
            "
            [attr.aria-describedby]="
              responsibleForm.get('headquarters')?.invalid &&
              responsibleForm.get('headquarters')?.touched
                ? 'headquarters-error'
                : null
            "
          />
          @if (isEditMode()) {
            <app-validation-error
              [control]="responsibleForm.get('headquarters')"
              errorId="headquarters-error"
              mode="address"
            />
          }
        </div>

        <div class="item">
          <label for="email">Email <span class="text-red-500" aria-hidden="true">*</span></label>
          <input
            id="email"
            pInputText
            type="email"
            formControlName="email"
            class="w-full"
            aria-required="true"
            [attr.aria-invalid]="
              responsibleForm.get('email')?.invalid && responsibleForm.get('email')?.touched
            "
            [attr.aria-describedby]="
              responsibleForm.get('email')?.invalid && responsibleForm.get('email')?.touched
                ? 'email-error'
                : null
            "
          />
          @if (isEditMode()) {
            <app-validation-error
              [control]="responsibleForm.get('email')"
              errorId="email-error"
              mode="strict"
            />
          }
        </div>
      </div>

      <!-- Button always visible in the section footer -->
      <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
        @if (!isEditMode()) {
          <p-button
            label="Modifica"
            [outlined]="true"
            size="small"
            (click)="toggleEdit()" [attr.aria-label]="'Modifica responsabile'"
            title="Modifica responsabile"
          ></p-button>
        } @else {
          <p-button
            label="Annulla"
            [outlined]="true"
            size="small"
            (click)="cancelEdit()" [attr.aria-label]="'Annulla modifiche'"
            title="Annulla modifiche"
          ></p-button>
          <p-button
            label="Salva"
            icon="pi pi-check"
            size="small"
            (click)="save()" [attr.aria-label]="'Salva modifiche responsabile'"
            title="Salva modifiche responsabile"
          ></p-button>
        }
      </div>
    </section>

    <!-- ================= SECTION 2: CONTRATTI ================= -->
    <app-contracts-registry
      [responsibleId]="responsibleId()"
      [parentBreadcrumb]="breadcrumbItems()"
    ></app-contracts-registry>
  } @else {
    <!-- Loading state -->
    <div class="p-4 text-center" role="status" aria-live="polite">
      <p-progressSpinner [attr.aria-label]="'Caricamento in corso'"></p-progressSpinner>
      <p class="mt-3">Caricamento dettagli responsible...</p>
    </div>
  }
</div>
